import React from 'react'
import PropTypes from 'prop-types'
import { Modal as EPModal, Copy, Box, themeMediaQuery } from '@elparking/components'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

export const Text = styled.div`
    width: 100%;
    height: auto;
    overflow-y: none;
    margin-bottom: 10px;
    ${themeMediaQuery('medium')} {
        height: 700px;
        max-height: calc(100vh - 100px);
        overflow-y: scroll;
    }
`

const ClickToCallGDPRModal = ({ isShown, onClose }) => {
    return <EPModal isShown={isShown} onClose={onClose} width='690px' height='800px' label=' ' showModalTitle={false} zIndex={99999999}>
        <Copy size={['large', 'xxLarge']} fontWeight='medium' color='accent_dark' padding='1em 0em'>
            <FormattedMessage defaultMessage='Política de privacidad'/>
        </Copy>
        <Text>
            <Copy size='small' fontWeight='regular'>
                <strong><FormattedMessage defaultMessage='RESPONSABLE' /></strong>{': '}
                <FormattedMessage defaultMessage='Autoclub Mutua Madrileña S.L.U. (en adelante ACM), con domicilio en Paseo de la Castellana, 33, 28046 de Madrid.' />
            </Copy>
            <Copy size='small' fontWeight='regular'>
                <strong><FormattedMessage defaultMessage='DELEGADO DE PROTECCION DE DATOS (DPO)' /></strong>{': '}
                <FormattedMessage defaultMessage='Podrás contactar con el DPO enviando un correo electrónico a dpo@mutua.es o en la dirección Paseo de la Castellana 33, 28046 Madrid.' />
            </Copy>
            <Copy size='small' fontWeight='regular'>
                <strong><FormattedMessage defaultMessage='FINALIDAD '/></strong>
                <FormattedMessage defaultMessage='Contactar contigo por teléfono para informarte sobre los productos en los que estás interesado.' />
            </Copy>
            <Copy size='small' fontWeight='regular'>
                <strong><FormattedMessage defaultMessage='LEGITIMACIÓN '/></strong>
                <FormattedMessage defaultMessage='Tu consentimiento.' />
            </Copy>
            <Copy size='small' fontWeight='regular'>
                <strong><FormattedMessage defaultMessage='DESTINATARIOS '/></strong>
                <FormattedMessage defaultMessage='No se cederán los datos a terceras entidades, salvo obligación legal.' />
            </Copy>
            <Copy size='small' fontWeight='regular'>
                <strong><FormattedMessage defaultMessage='PLAZO DE CONSERVACIÓN DE LOS DATOS '/></strong>
                <FormattedMessage defaultMessage='ACM conservará tus datos durante el plazo de cuatro meses a contar desde tu solicitud de contacto para poder contactar contigo en este plazo.' />
            </Copy>
            <Copy size='small' fontWeight='regular'>
                <strong><FormattedMessage defaultMessage='CUÁLES SON TUS DERECHOS DE PROTECCIÓN DE DATOS '/></strong>
                <FormattedMessage defaultMessage='Podrás obtener la información necesaria para ejercer tus derechos de protección de datos. Por ello, podrás:' />
                <Box mR='2em'>
                    <Copy size='small' padding='0' fontWeight='regular'>
                        {'·'} <FormattedMessage defaultMessage='Solicitar el acceso para consultar tus datos personales que estamos tratando.'/>
                    </Copy>
                    <Copy size='small' padding='0' fontWeight='regular'>
                        {'·'} <FormattedMessage defaultMessage='Solicitar su rectificación para la modificación de tus datos personales.'/>
                    </Copy>
                    <Copy size='small' padding='0' fontWeight='regular'>
                        {'·'} <FormattedMessage defaultMessage='Solicitar la supresión o Derecho al olvido para suprimir tus datos personales.'/>
                    </Copy>
                    <Copy size='small' padding='0' fontWeight='regular'>
                        {'·'} <FormattedMessage defaultMessage='Solicitar la oposición y/o decisiones individuales automatizadas para que tus datos no se traten para determinados usos.'/>
                    </Copy>
                    <Copy size='small' padding='0' fontWeight='regular'>
                        {'·'} <FormattedMessage defaultMessage='Solicitar la limitación de su tratamiento, para la limitar de forma temporal el uso de tus datos en determinados supuestos.'/>
                    </Copy>
                    <Copy size='small' padding='0' fontWeight='regular'>
                        {'·'} <FormattedMessage defaultMessage='Solicitar la portabilidad de tus datos personales para que sean entregados.'/>
                    </Copy>
                </Box>
            </Copy>
            <Copy size='small' fontWeight='regular'>
                <FormattedMessage defaultMessage='Para ejercitar cualquiera de estos derechos, deberás dirigirte por escrito (asunto LOPD, Derechos) a la Unidad de Protección de Datos, enviando un correo electrónico a protecciondatos@mutua.es o por correo postal a la dirección de Paseo de la Castellana, 33, 28046 Madrid o llamando al teléfono gratuito 900102711.' />
            </Copy>
            <Copy size='small' fontWeight='regular'>
                <FormattedMessage defaultMessage='Además, si lo deseas podrás presentar una reclamación ante la Agencia Española de Protección de datos si consideras que el tratamiento que estamos realizando es contrario a la normativa en vigor.' />
            </Copy>
            <Copy size='small' fontWeight='regular'>
                <FormattedMessage defaultMessage='El envío de los datos supone la aceptación expresa para la realización de los anteriores tratamientos de datos. Es imprescindible rellenar todos los datos requeridos para poder gestionar tu solicitud.' />
            </Copy>
        </Text>
    </EPModal>
}

ClickToCallGDPRModal.propTypes = {
    onClose: PropTypes.func,
    isShown: PropTypes.bool,
}

export default ClickToCallGDPRModal
